﻿let reset = false;
const History = window.History; // Note: We are using a capital H instead of a lower h
function getActiveFuelTypes() {
    const greenButtons = $('[data-fuel-type] a.btn-green');

    const values = $.map(greenButtons, function (element, index) {
        return $(element).attr('value');
    });

    return values.join(',');
}

function handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== 'undefined') {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;

        console.log('TextDiv Height:', textDivHeight); // Debugging: Check the height

        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) {
                existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            }

            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);

            toggleBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 1.2 * 16) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });

            console.log('Toggle Button Added'); // Debugging: Confirm button is added
        }
    } else {
        console.log('TextDiv not found'); // Debugging: Check if textDiv is found
    }
}

function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({ cache: false });
    $.get('/new-van-running-cost/query', State.data, function (response) {
        $('#new-van-running-cost-query-container').replaceWith(response);
        handleBodyCopyToggle();
    });
    $.get('/new-van-running-cost/bottom-seo', State.data, function (response) {
        $('#new-van-running-cost-seo-container').replaceWith(response);
        handleBodyCopyToggle();
    });
}

function markAsLoading() {
    let container = $('#new-van-running-cost-results-container');
    container.height(container.height()); // set the height to stop moving on large desktop
    container.text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function setOperatingCycle() {
    $.get("/cap-van-operating-cycles/miles/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Miles").val(response);
    });
    $.get("/cap-van-operating-cycles/years/" + $('#DefaultOperatingCycleId').val(), function (response) {
        $("#Years").val(response);
    });
}

function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown == "OperatingCycleId") {
        const id = $(this).val();
        $.get("/cap-van-operating-cycles/miles/" + id, function (response) {
            $("#Miles").val(response);
            $.get("/cap-van-operating-cycles/years/" + id, function (response) {
                $("#Years").val(response);
                window.updateVanRunningCosts();
            });
        });
    } else if (currentDropdown == "ManufacturerId") {
        $("#ModelGroupId").val('');
        $("#Model").val('');
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $(this).val(), function (response) {
                $("#Manufacturer").val(response);
                window.updateVanRunningCosts();
            });
        } else {
            $("#Manufacturer").val('');
            window.updateVanRunningCosts();
        }
        
    } else if (currentDropdown == "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $('#ManufacturerId').val(), function (response) {
                $("#Manufacturer").val(response);
                window.updateVanRunningCosts();
            });
            $.get("/cap-van-model-url/" + $('#ManufacturerId').val() + "/" + $(this).val(), function (response) {
                $("#Model").val(response);
                window.updateVanRunningCosts();
            });
        } else {
            $("#Model").val('');
            window.updateVanRunningCosts();
        }
    } else if (currentDropdown == "VehicleGroupId") {
        $("#ModelGroupId").val('');
        if (parseInt($('#VehicleGroupId').val()) > 0) {
            $.get("/cap-van-type-url/" + $('#VehicleGroupId').val(), function (response) {
                $("#VanType").val(response);
                window.updateVanRunningCosts();
            });
        } else {
            $("#VanType").val('');
            window.updateVanRunningCosts();
        }
    } else {
        window.updateVanRunningCosts();
    }
}

//sorting the results
function sortResults(event) {
    event.preventDefault();

    const newSortBy = $(this).data('new-running-cost-sort');
    const sortByEl = $('#SortBy');
    const sortDescEl = $('#SortDesc');

    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() == "true") {
        sortDescEl.val("false");
    } else {
        sortDescEl.val("true");
    }

    window.updateVanRunningCosts();
}

function showHideDetail() {
    const $this = $(this);
    let id = $this.attr('href');

    let collapsibleElement = document.querySelector(id);
    if (window.isViewportLessThan('md')) {
        collapsibleElement = document.querySelector(`tr.child ${id}`);
    }

    if (collapsibleElement) {
        if (!collapsibleElement.dataset.eventInitiated) {
            collapsibleElement.addEventListener('shown.bs.collapse', function (e) {
                this.dataset.eventInitiated = true;
                let spacer = $(collapsibleElement).closest('tr').next('tr.spacer');
                if (spacer) {
                    spacer.find('td').attr('height', $(this).height());
                }
            });
        }
    }

    const currentText = $.trim($this.text());
    const row = $this.parents('tr');
    let currentSpacer = $this.closest('table').find('.spacer[data-id="' + id + '"]');
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text('Hide data');
        if (currentSpacer.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo('xl')) {
                row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize()=='lg') {
                if (rowHeight > 40) {
                    row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="145"></td></tr>');
                } else {
                    row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
                }
            } else if (window.getViewportSize()=='md') {
                row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="190"></td></tr>');
            } else {
                row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="400"></td></tr>');
            }
        }
    } else {

        $this.text('View data');
        currentSpacer.remove();
    }

    resetSpacersSize();
}

//sorting arrow
function applyResultsSortArrows() {
    const sortBy = $('#SortBy').val();
    $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $('#SortDesc').val();
    if (sortDesc.toLowerCase() == "true") {
        $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
    }
}

function setManufacturer(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ManufacturerId') > 1) {
            const manId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ManufacturerId";
            })[0].split('=')[1];
            $.get("/cap-van-manufacturer-url/" + manId, function (response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf('Manufacturer') > 1) {
            const manufacturer = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "Manufacturer";
            })[0].split('=')[1];

            $("#Manufacturer").val(manufacturer);
        }
    }
}

function setModel(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ModelGroupId') > 1) {
            const modelId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ModelGroupId";
            })[0].split('=')[1];
            const manufacturerId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ManufacturerId";
            })[0].split('=')[1];
            $.get("/cap-van-model-url/" + manufacturerId + "/" + modelId, function (response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf('Model') > 1) {
            const model = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "Model";
            })[0].split('=')[1];

            $("#Model").val(model);
        }
    }
}

function setVanType(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('VehicleGroupId') > 1) {
            const vehicleGroupId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "VehicleGroupId";
            })[0].split('=')[1];
            $.get("/cap-van-type-url/" + vehicleGroupId, function (response) {
                $("#VanType").val(response);
            });
        } else if (href.indexOf('VanType') > 1) {
            const carType = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "VanType";
            })[0].split('=')[1];

            $("#VanType").val(carType);
        }
    }
}

function checkIsDigitsOnly(e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && e.which != 13 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        //display error message
        const id = $(e.target).attr('id');
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }

    return true;
}

function loadAsDataTable() {
    const table = $('#new-running-costs').DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function (oSettings) {
            $('.dataTables_paginate').hide();
        }
    });

    //Check spacer when datatable responsive display collapsed (hide)
    table.on('responsive-display.dt', function (e, datatable, row, showHide, update) {
        resetSpacersSize();
    });
}

function addVehicle(id, callback) {
    $.get("/van-compare-list/handle/add/" + id, function (response) {
        let success;
        if (response == 0) {
            success = true;
        } else if (response == 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response == 2) {
            success = true;
        } else {
            alert("Error");
            success = false;
        }
        if (callback) {
            callback(success);
        }
    });
}

function removeVehicle(id, callback) {
    $.get("/van-compare-list/handle/remove/" + id, function (response) {
        const success = response == 0;
        if (callback) {
            callback(success);
        }
    });
}

function markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text('Add to compare');
}

function markAsToRemove(btn) {
    btn.html(btn.data('original-text'));
    btn.addClass("added");
    btn.text("Comparing");
}

function updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("new-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data('original-text')) {
        btn.data('original-text', btn.html());
    }

    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) {
        removeVehicle(data, function (success) {
            if (success) {
                markAsToAdd(btn);
                reloadQuery();
            } else {
                markAsToRemove(btn);
            }
            reloadQuery();
        });
    } else {
        addVehicle(data, function (success) {
            if (success) {
                markAsToRemove(btn);
                $("html, body").animate({ scrollTop: 0 }, "slow");
                reloadQuery();
            } else {
                markAsToAdd(btn);
            }
        });
    }
}

function updateFuelTypes(event) {
    //markAsLoading();
    $(event.target).toggleClass('btn-green').toggleClass('btn-primary');
    event.preventDefault();
    window.updateVanRunningCosts();
}

$(function () {
});

function buildUpQueryString(data) {
    let queryString = "";

    //var operatingCycleDefault = $('#OperatingCycleId option').eq(0).val();
    //if (data.OperatingCycleId != operatingCycleDefault) {
    //    if (queryString.length > 0) queryString += "&";
    //    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;
    //}

    if (queryString.length > 0) queryString += "&";
    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;

    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) {
        queryString += "VanType=" + data.VanType;
    } else {
        queryString += "VanType=";
    }

    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;

    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;

    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.P;
    }

    if (queryString.length > 0) queryString += "&";
    queryString += "MinPayload=" + data.MinPayload;

    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadWidth=" + data.MinLoadWidth;

    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadLength=" + data.MinLoadLength;

    if (queryString.length > 0) queryString += "&";
    queryString += "MinTow=" + data.MinTow;

    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceFrom=" + data.BIKPriceFrom;

    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceTo=" + data.BIKPriceTo;

    if (queryString.length > 0) queryString += "&";
    queryString += "CO2From=" + data.CO2From;

    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;

    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;

    return "?" + queryString;
}

function getData(page) {
    const operatingCycleId = $('#OperatingCycleId').val();
    const vehicleGroupId = $('#VehicleGroupId').val();
    const manufacturerId = $('#ManufacturerId').val();
    const modelGroupId = $('#ModelGroupId').val();
    const miles = $('#Miles').val();
    const years = $('#Years').val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const vanType = $("#VanType").val();
    const co2From = $('#CO2From').val();
    const co2To = $('#CO2To').val();
    const minPayload = $('#MinPayload').val();
    const minLoadWidth = $('#MinLoadWidth').val();
    const minLoadLength = $('#MinLoadLength').val();
    const minTow = $('#MinTow').val();
    const bikPriceFrom = $('#BIKPriceFrom').val();
    const bikPriceTo = $('#BIKPriceTo').val();
    const sortBy = $('#SortBy').val();
    const sortDesc = $('#SortDesc').val();
    const fuelType = getActiveFuelTypes();

    return {
        OperatingCycleId: operatingCycleId,
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Miles: miles,
        Years: years,
        Manufacturer: manufacturer,
        Model: model,
        VanType: vanType,
        MinPayload: minPayload,
        MinLoadWidth: minLoadWidth,
        MinLoadLength: minLoadLength,
        MinTow: minTow,
        BIKPriceFrom: bikPriceFrom,
        BIKPriceTo: bikPriceTo,
        CO2From: co2From,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}

function updateResultsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

function pageData(event) {
    event.preventDefault();
    if ($(this).attr('href') === undefined)
        return;
    const page = getPage($(this).attr('href'));
    updateResultsLogic(page);
}

function getPage(href) {
    const querystring = href.split('?')[1];
    const parts = querystring.split('&');
    return $.grep(parts, function (el, index) {
        return el.split('=')[0] == "p";
    })[0].split('=')[1];
}


function updateState() { // Note: We are using statechange instead of popstate#
    markAsLoading();
    reloadQuery();
    const State = History.getState();
    $.get('/new-van-running-cost/results', State.data, function (response) {
        $('#new-van-running-cost-results-container').replaceWith(response);

        $("#new-van-running-cost-results-container input[name^='comparelist']").each(function () {
            const compareListId = $(this).val();
            $("[data-new-compare-list-add-id=" + compareListId + "]").addClass("added").text('Comparing');
        });

        loadAsDataTable();
        applyResultsSortArrows();

        if (reset) {
            $('[data-no-results]').hide();
            $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
            reset = false;
        }
    }).done(function () {
        setTimeout(function () {
            // //delay reload until results show, as we are now injecting ads into content
            const adSection = $("[data-ad-id]");
            // //push slots
            //
            const page = window.getDFPAdsPage(adSection);
            // window.getDFPAds(page);
            // if (page.adSlots['leaderboard-2'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-2-container"));
            // }
            // if (page.adSlots['leaderboard-3'] === undefined) {
            //     window.pushAdSlot(page, $("#leaderboard-3-container"));
            // }

            window.getDFPAds(page, hideIfNoAd)
        }, 250);
    });

    function hideIfNoAd() {
        //the below works but then the even/odd table needs adjusting and more work that worth.
        /* setTimeout(function(){
             let $vanrunningcost = $("#vanrunningcost-ad-slot-1");   
             const len = $$vanrunningcost.html().length;
             if (len === 0){
                 $vanrunningcost.parent().parent().parent().hide();
             } else {
                 $vanrunningcost.parent().parent().parent().show();
             }
         }, 1000);   */
    }
}
function setupMpus() {
    if (window.location.pathname === '/tools/van/running-costs/' && window.location.search !== '') {
        if ($('#mpus').length) {
            $('#mpus').remove();
        }
    }
}

function resetSpacersSize() {
    $('.spacer[data-id]').each(function () {
        let spacer = $(this);
        let id = spacer.data('id');
        let collapsibleElement = document.querySelector(id);
        if (window.isViewportLessThan('md')) {
            collapsibleElement = document.querySelector(`tr.child ${id}`);
        }
        if (collapsibleElement) {
            if (collapsibleElement.offsetParent !== null && $(collapsibleElement).height() > 0) {
                spacer.find('td').attr('height', $(collapsibleElement).height());
            }
            else {
                spacer.remove();
            }
        }
        else {
            spacer.remove();
        }
    });
}

export function setupVanRunningCosts() {
    if (!$('[data-new-van-running-costs]').length) {
        return;
    }
    setupMpus();
    setOperatingCycle();
    setManufacturer(window.location.href);
    setVanType(window.location.href);
    setModel(window.location.href);
    loadAsDataTable();
    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
    $('[data-no-results]').hide();

    //dropdown changes
    $(document).on('change', '[data-new-van-running-costs] input, [data-new-van-running-costs] select', onChangeFilters);

    $(document).on('keypress', '[data-new-van-running-costs] input', function (e) {
        if (e.keyCode == 13) {
            onChangeFilters();
            return false;
        }
    });

    //paging click
    $(document).on('click', '#new-van-running-cost-results-container .pagination a', pageData);

    //fuel type button chagnes
    $(document).on('click', '[data-fuel-type] a', updateFuelTypes);

    //sort
    $(document).on("click", "[data-new-running-cost-sort]", sortResults);

    window.addEventListener("resize", function () {
        resetSpacersSize();
    });

    //viewdata
    $(document).on("click", "[data-view-detail]", showHideDetail);

    //digit only
    $(document).on('keypress', "[data-digits-only]", checkIsDigitsOnly);

    //arrow
    applyResultsSortArrows();

    //reset
    $(document).on("click", "[data-reset-button]", function (event) {
        event.preventDefault();
        History.pushState({}, $('title').html(), location.pathname);
        reset = true;
    });

    //add to compare list button click
    $(document).on("click", "[data-new-compare-list-add-id]", updateCompareList);

    //derivative link
    $(document).on("click", "[data-derivative]", function (e) {
        e.preventDefault();
        let viewDetailsButton = $(this).parents('tr').find('[data-view-detail]');

        if (viewDetailsButton.length) {
            if (window.isViewportLessThan('md')) {
                $(this).closest('tr').find('.dtr-control').trigger("click");
            } else {
                let id = viewDetailsButton.attr('href');
                let collapsibleElement = document.querySelector(id);
                if (window.isViewportLessThan('md')) {
                    collapsibleElement = document.querySelector(`tr.child ${id}`);
                }

                if (collapsibleElement) {
                    viewDetailsButton.toggleClass('collapsed');
                    viewDetailsButton.data('aria-expanded', !viewDetailsButton.data('aria-expanded'));
                    $(collapsibleElement).toggleClass('show');

                    $(this).closest('tr').find('[data-view-detail]').trigger("click");
                }
            }
        }
        resetSpacersSize();
    });

    // Bind to StateChange Event
    History.Adapter.bind(window, 'statechange', updateState);

    window.updateVanRunningCosts = function () {
        updateResultsLogic(1);
        setupMpus();
    }

}